
var assist = {
  slideDownOnInit: true,
  init: function () {

    if (assist.slideDownOnInit) {
      $('.assist-bar').hide().slideDown();
    }

    $('html').addClass('assist-view assist-normal assist-white');

    Cookies.set('assist_view', 'on', {expires: 90, path: '/'});
    if (Cookies.get('assist_color') === undefined) {
      Cookies.set('assist_color', 'color-normal', {expires: 90, path: '/'});
    }
    if (Cookies.get('assist_size') === undefined) {
      Cookies.set('assist_size', 'size-normal', {expires: 90, path: '/'});
    }
    $(window).resize();

    assist.bindControls();

    if (Cookies.get('assist_view') != undefined) {
      assist.slideDownOnInit = false;
      //sizeSelector.click();
      if (Cookies.get('assist_size') != undefined) {
        $('.assist-bar li.' + Cookies.get('assist_size')).click();
      }
      if (Cookies.get('assist_color') != undefined) {
        $('.assist-bar li.' + Cookies.get('assist_color')).click();
      }
      if (Cookies.get('assist_image_disable') != undefined) {
        $('.assist-bar .image-switcher').click();
      }
    }
  },
  bindControls: function () {

    var html = $('html');
    var bar = $('.assist-bar');
    bar.find('.size-select li').each(function () {
      $(this).click(function () {
        bar.find('.size-select li.active').removeClass('active');
        Cookies.set('assist_size', $(this).attr('class'), {expires: 90, path: '/'});
        $(this).addClass('active');
        html.removeClass('assist-normal assist-medium assist-large');
        html.addClass($(this).attr('data-classname'));
        $(window).resize();
      });
    });
    bar.find('.color-select li').each(function () {
      $(this).click(function () {
        bar.find('.color-select li.active').removeClass('active');
        Cookies.set('assist_color', $(this).attr('class'), {expires: 90, path: '/'});
        $(this).addClass('active');
        html.removeClass('assist-white assist-invert assist-blue');
        html.addClass($(this).attr('data-classname'));
      });
    });
    bar.find('.image-switcher').click(function () {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active').html('Выкл');
        Cookies.set('assist_image_disable', 'on', {path: '/', expires: 30});
        html.addClass('assist-no-image');
      }
      else {
        $(this).removeClass('active').html('Вкл');
        Cookies.set('assist_image_disable', 'off', {path: '/', expires: -5});
        html.removeClass('assist-no-image');
      }
      $(window).resize();
    });

    bar.find('.view-switcher').click(function () {
      Cookies.set('assist_view', 'off', {expires: -1, path: '/'});
      window.location.reload();
      /*

       $('.assist-bar').slideUp(function () {
       //$(this).remove();
       });
       */
    });
  }
};

$(document).ready(function () {
  $('.assist-init').click(function () {
    assist.init();
    //$('.assist-init').hide();
  });
  assist.bindControls();
});